<!-- eslint-disable max-len -->
<template>
  <v-stepper-content step="7" :class="$vuetify.breakpoint.name === 'xs' ? 'px-0' : ''">
    <v-col
      cols="12"
      :class="$vuetify.breakpoint.name !== 'sm' ? 'd-flex justify-center mx-0 px-0' : 'd-flex justify-center'"
    >
      <v-card
        flat
        outlined
        rounded="lg"
        :max-width="$vuetify.breakpoint.name === 'xs' ? '95vw' : '75vw'"
        min-height="500px"
      >
        <v-row :class="$vuetify.breakpoint.name === 'xs' ? 'mt-8 mx-1' : 'mt-8 mx-5'">
          <v-col cols="12" class="pb-0">
            <div class="text-md-h4 text-h5" :style="textColor">Tax Preparer Information</div>
          </v-col>
          <v-col cols="12" class="pb-1">
            <div class="text-subtitle-2 font-italic">*The information below is not required for initial proposal but it is required for final underwriting and contract submission.</div>
          </v-col>
          <v-col cols="12" class="text-body-2">
            <div>{{ messages.TaxPreparerMessage }}</div>
          </v-col>

          <v-col cols="12" class="mt-4 pb-0">
            <div class="text-md-body-1 text-body-2">Disclosure Authorization</div>
          </v-col>
          <v-col cols="12" class="pb-1">
            <div class="text-subtitle-2 font-italic">This authorization will be effective until revoked by me (us).</div>
          </v-col>

          <v-col cols="12" class="mt-8">
            <v-text-field
              outlined
              label="Preparer Name"
              class="rounded-lg"
              hide-details
              v-model="contactName"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field
              outlined
              label="Firm Name"
              class="rounded-lg"
              hide-details
              v-model="firmName"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field
              outlined
              label="Street Address"
              class="rounded-lg"
              hide-details
              v-model="contactAddress"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              outlined
              label="City"
              class="rounded-lg"
              hide-details
              v-model="contactCity"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <v-combobox
              v-model="contactState"
              :items="states"
              item-value="Abbr"
              item-text="Full"
              outlined
              label="State"
              class="rounded-lg"
              hide-details
              :return-object="false"
            ></v-combobox>
          </v-col>

          <v-col cols="12" sm="3">
            <v-text-field
              outlined
              label="Postal Code"
              class="rounded-lg"
              hide-details
              v-model="contactZip"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              outlined
              label="Phone Number"
              class="rounded-lg"
              hide-details
              v-model="contactPhone"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              outlined
              label="Email"
              class="rounded-lg"
              hide-details
              v-model="contactEmail"
            ></v-text-field>
          </v-col>

          <BtnContinue />
        </v-row>
      </v-card>
    </v-col>
  </v-stepper-content>
</template>

<script>
import States from '@/Data/States';
import Messages from '@/Data/Messages';
import BtnContinue from '../../btnContinue.vue';

export default {
  name: 'StepSeven',
  components: {
    BtnContinue,
  },
  data: () => ({
    states: States,
    messages: Messages,
    selectedState: null,
  }),
  computed: {
    textColor() {
      if (this.$vuetify.theme.dark) {
        return 'color: #ffffff';
      }

      return 'color: #2a4f66';
    },
    contactType() {
      return this.$store.state.prospectPacket.taxPreparer.contactType;
    },
    contact: {
      get() {
        return this.$store.state.prospectPacket.contacts.find((x) => x.contactType === this.contactType);
      },
      set(value) {
        this.$store.state.commit('updateContactObject', value);
      },
    },
    firmName: {
      get() {
        return this.$store.state.prospectPacket.taxPreparer.firmName;
      },
      set(value) {
        this.$store.commit('updateFirmName', value);
      },
    },
    contactName: {
      get() {
        if (this.contact === undefined) {
          return '';
        }
        return this.contact.name;
      },
      set(value) {
        this.contact.name = value;
      },
    },
    contactAddress: {
      get() {
        if (this.contact === undefined) {
          return '';
        }
        return this.contact.address1;
      },
      set(value) {
        this.contact.address1 = value;
      },
    },
    contactCity: {
      get() {
        if (this.contact === undefined) {
          return '';
        }
        return this.contact.city;
      },
      set(value) {
        this.contact.city = value;
      },
    },
    contactState: {
      get() {
        if (this.contact === undefined) {
          return '';
        }
        return this.contact.state;
      },
      set(value) {
        this.contact.state = value;
      },
    },
    contactZip: {
      get() {
        if (this.contact === undefined) {
          return '';
        }
        return this.contact.zip;
      },
      set(value) {
        this.contact.zip = value;
      },
    },
    contactPhone: {
      get() {
        if (this.contact === undefined) {
          return '';
        }
        return this.contact.phone;
      },
      set(value) {
        this.contact.phone = value;
      },
    },
    contactEmail: {
      get() {
        if (this.contact === undefined) {
          return '';
        }
        return this.contact.email;
      },
      set(value) {
        this.contact.email = value;
      },
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
